export class KafkaBatchConfig {
    'mode';
    'maxRecordsPerBatch';
    'maxBatchIntervalSeconds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mode",
            "baseName": "mode",
            "type": "BatchMode",
            "format": ""
        },
        {
            "name": "maxRecordsPerBatch",
            "baseName": "maxRecordsPerBatch",
            "type": "number",
            "format": ""
        },
        {
            "name": "maxBatchIntervalSeconds",
            "baseName": "maxBatchIntervalSeconds",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaBatchConfig.attributeTypeMap;
    }
    constructor() {
    }
}
